import { render, staticRenderFns } from "./resultLis.vue?vue&type=template&id=2f465bfe&scoped=true&"
import script from "./resultLis.vue?vue&type=script&lang=js&"
export * from "./resultLis.vue?vue&type=script&lang=js&"
import style0 from "./resultLis.vue?vue&type=style&index=0&id=2f465bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f465bfe",
  null
  
)

export default component.exports